// extracted by mini-css-extract-plugin
module.exports = {"balanceWithPayment":"gqWbUF7RVEbY96o7zEpn","budgetInput":"qTOuCXHE7NDyoSlfHf93","info":"juXiXMQ54Ye2ewEvoEYG","note":"CV_zkCO67pfNInOiATXg","popover":"qzRZ_VPhYeZiY7FyAc6y"};